import './../../shop/modules/multi_checkout/services.multi-checkout';
import './../../shop/modules/services.tcat_seven_eleven';
import onLogError from '../../utils/onLogError';
import { createPromiseFunctionWithDelay } from '../../utils/promise';
import { DESTINATION_TYPES } from './constants/destinationType';
import { PAGE_TYPE } from '../../constants/logger';
app.directive('destinationSectionTcatSevenEleven', [
  'tcatSevenElevenService',
  'multiCheckoutService',
  function (tcatSevenElevenService, multiCheckoutService) {
    return {
      restrict: 'E',
      templateUrl: require('../../../../../public/themes/shared/multi_checkout/templates.destination-section.tcat-seven-eleven.html'),
      scope: {
        store: '=',
        disabled: '=',
        cartTagIds: '=',
        errorMessage: '=',
        updateDestination: '<',
        contractCode: '@',
        tcatStoreCategory: '@',
      },
      link: function (scope) {
        scope.actionUrl = () => tcatSevenElevenService.getEMapUrl();
        scope.callbackUrl = () => tcatSevenElevenService.getEMapCallbackUrl();
        scope.eMapFormId = () =>
          `multi_checkout_tcat_seven_${scope.cartTagIds.join('-')}`;

        const trackerPromiseWithDelay = createPromiseFunctionWithDelay(() => {
          multiCheckoutService.trackFillRecipientData(
            DESTINATION_TYPES.TW_TCAT_711PICKUP_ROOMTEMP_EMAP_ONLY,
          );
        });

        scope.onEMapSubmitClick = (event) => {
          event.preventDefault();
          scope
            .updateDestination()
            .then(() =>
              Promise.all([
                multiCheckoutService.saveSessionData({
                  cart_tag_ids: scope.cartTagIds,
                }),
                trackerPromiseWithDelay(),
              ]),
            )
            .then(() => {
              $(`#${scope.eMapFormId()}`).submit();
            })
            .catch((error) => {
              onLogError({
                error,
                page: PAGE_TYPE.cart,
                debugMessage: 'unable to open e-map of tcat seven eleven.',
                sourceName:
                  'destinationSectionTcatSevenEleven#onEMapSubmitClick',
              });
            });
        };
      },
    };
  },
]);
